const toHex = (bytes: Uint8Array): string => Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('')

export const createId = (): string => {
    const cryptoApi = typeof globalThis === 'undefined' ? undefined : globalThis.crypto

    if (cryptoApi && typeof cryptoApi.randomUUID === 'function') return cryptoApi.randomUUID()

    const bytes = new Uint8Array(16)

    if (cryptoApi && typeof cryptoApi.getRandomValues === 'function') cryptoApi.getRandomValues(bytes)
    else for (let index = 0; index < bytes.length; index += 1) bytes[index] = Math.floor(Math.random() * 256)

    bytes[6] = (bytes[6] & 0x0f) | 0x40
    bytes[8] = (bytes[8] & 0x3f) | 0x80

    const hex = toHex(bytes)
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}

export const formatInvoiceNumber = (prefix: string, value: number): string => `${prefix}${String(value).padStart(4, '0')}`

export const formatJobNumber = (value: number): string => `#${String(value).padStart(4, '0')}`
